define('lq/events/actions/startImpersonatingCommand',[
    'lq',
    'lq/events/actions/eventAction'
], function(lq, EventAction) {
    'use strict';

    function StartImpersonatingCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.eventData = eventData;
        return this;
    };

    EventAction.extend(StartImpersonatingCommand, EventAction);

    StartImpersonatingCommand.typeName = 'StartImpersonatingCommand';

    StartImpersonatingCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    StartImpersonatingCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'StartImpersonating',
            command: this.eventData.command
        };
    };

    StartImpersonatingCommand.prototype.execute = function (continuation, eventActionResponse) {
        var self = this;
        if (eventActionResponse.status === 'success')
            // the page now runs as the impersonated user: take over its token before anything else is sent
            this.refreshCsrfTokenForNewUser(function () {
                self.triggerEventIfEnabledAndContinue('impersonationStarted', continuation);
            });
        else
            this.triggerEventIfEnabledAndContinue('impersonationStartFailed', continuation, eventActionResponse.description);
    };

    return StartImpersonatingCommand;
});

